import jsonData from "./data.json";

export const createVideo = async (tokenID, bgImage, faceImage) => {
  let objJson = { ...jsonData };
  console.log(objJson);

  const editedJson = JSON.stringify(objJson)
};
